(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-box-builder]';

    class BoxBuilder {
      constructor(section) {
        this.section = section;
        this.modal = section.querySelector('[data-builder-modal]');

        this.packTriggers = Array.from(
          section.querySelectorAll('[data-pack-trigger]')
        );

        this.packCards = Array.from(
          section.querySelectorAll('[data-pack-card]')
        );

        this.closeButtons = Array.from(
          section.querySelectorAll('[data-builder-close]')
        );

        this.flavours = Array.from(
          section.querySelectorAll('[data-flavour]')
        );

        this.cookieDetailsModal = section.querySelector(
          '[data-cookie-details-modal]'
        );

        this.cookieDetailsCloseButtons = Array.from(
          section.querySelectorAll('[data-cookie-details-close]')
        );

        this.cookieDetailTitle = section.querySelector(
          '[data-cookie-detail-title]'
        );

        this.cookieDetailImage = section.querySelector(
          '[data-cookie-detail-image]'
        );

        this.cookieDetailCompare = section.querySelector(
          '[data-cookie-detail-compare]'
        );

        this.cookieDetailPrice = section.querySelector(
          '[data-cookie-detail-price]'
        );

        this.cookieDetailTags = section.querySelector(
          '[data-cookie-detail-tags]'
        );

        this.cookieDetailAllergens = section.querySelector(
          '[data-cookie-detail-allergens]'
        );

        this.cookieDetailAdd = section.querySelector(
          '[data-cookie-detail-add]'
        );

        this.cookieDetailProduct = section.querySelector(
          '[data-cookie-detail-product]'
        );

        this.fourCookieUpsell = section.querySelector(
          '[data-four-cookie-upsell]'
        );

        this.fourCookieUpsellCopy = section.querySelector(
          '[data-four-cookie-upsell-copy]'
        );

        this.fourCookieUpsellUpgrade = section.querySelector(
          '[data-four-cookie-upgrade]'
        );

        this.fourCookieUpsellKeepButtons = Array.from(
          section.querySelectorAll('[data-four-cookie-keep]')
        );

        this.activeFlavour = null;
        this.lastDetailsTrigger = null;

        this.preview = section.querySelector(
          '[data-builder-preview]'
        );

        this.selectedPreview = section.querySelector(
          '[data-selected-preview]'
        );

        this.singleCookieModalNote = section.querySelector(
          '[data-single-cookie-modal-note]'
        );

        this.singleCookieNote =
          section.dataset.singleCookieNote ||
          'Single cookies are packed individually. No box is included.';

        this.selectedCountElement = section.querySelector(
          '[data-selected-count]'
        );

        this.requiredCountElement = section.querySelector(
          '[data-required-count]'
        );

        this.previewPack = section.querySelector(
          '[data-preview-pack]'
        );

        this.countMessage = section.querySelector(
          '[data-count-message]'
        );

        this.countProgress = section.querySelector(
          '[data-count-progress]'
        );

        this.packPrice = section.querySelector(
          '[data-pack-price]'
        );

        this.packDiscountLabels = Array.from(
          section.querySelectorAll('[data-pack-discount-label]')
        );

        this.addButton = section.querySelector(
          '[data-add-box]'
        );

        this.addLabel = section.querySelector(
          '[data-add-label]'
        );

        this.addPrice = section.querySelector(
          '[data-add-price]'
        );

        this.message = section.querySelector(
          '[data-builder-message]'
        );

        this.packSize = 0;
        this.singleCookieLimit = 3;
        this.packLabel = '';
        this.packVariantId = '';
        this.packAvailable = false;
        this.selection = new Map();
        this.currentDiscountPercent = 0;
        this.currentVariantOptionValue = '';
        this.fourCookieUpsellShown = false;

        this.currencyCode =
          section.dataset.currencyCode || 'INR';

        this.handleEscape = this.handleEscape.bind(this);

        this.bindEvents();
        this.openFromUrl();
      }

      bindEvents() {
        this.packTriggers.forEach(trigger => {
          trigger.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            this.openPack(trigger);
          });
        });

        this.packCards.forEach(card => {
          const trigger = card.querySelector('[data-pack-trigger]');

          if (!trigger) {
            return;
          }

          card.addEventListener('click', event => {
            const interactiveElement = event.target.closest(
              'button, a, input, select, textarea'
            );

            if (interactiveElement) {
              return;
            }

            event.preventDefault();
            this.openPack(trigger);
          });

          card.addEventListener('keydown', event => {
            if (event.key !== 'Enter' && event.key !== ' ') {
              return;
            }

            event.preventDefault();
            this.openPack(trigger);
          });
        });

        this.closeButtons.forEach(button => {
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            this.close();
          });
        });

        this.flavours.forEach(flavour => {
          const decrease = flavour.querySelector('[data-decrease]');
          const increase = flavour.querySelector('[data-increase]');
          const detailTriggers = Array.from(
            flavour.querySelectorAll('[data-open-flavour-details]')
          );

          detailTriggers.forEach(trigger => {
            trigger.addEventListener('click', event => {
              event.preventDefault();
              event.stopPropagation();
              this.openFlavourDetails(flavour, trigger);
            });
          });

          decrease?.addEventListener('click', event => {
            event.preventDefault();
            this.changeQuantity(flavour, -1);
          });

          increase?.addEventListener('click', event => {
            event.preventDefault();
            this.changeQuantity(flavour, 1);
          });
        });

        this.cookieDetailsCloseButtons.forEach(button => {
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            this.closeFlavourDetails();
          });
        });

        this.cookieDetailAdd?.addEventListener('click', event => {
          event.preventDefault();
          this.addActiveFlavourFromDetails();
        });

        this.cookieDetailProduct?.addEventListener('click', event => {
          event.preventDefault();
          this.openActiveFlavourProduct();
        });

        this.fourCookieUpsellUpgrade?.addEventListener('click', event => {
          event.preventDefault();
          this.upgradeToFourCookieBox();
        });

        this.fourCookieUpsellKeepButtons.forEach(button => {
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            this.closeFourCookieUpsell();
          });
        });

        this.addButton?.addEventListener('click', event => {
          event.preventDefault();
          this.addToCart();
        });

        document.addEventListener('keydown', this.handleEscape);
      }

      handleEscape(event) {
        if (event.key !== 'Escape') {
          return;
        }

        if (
          this.fourCookieUpsell?.classList.contains('is-open')
        ) {
          this.closeFourCookieUpsell();
          return;
        }

        if (
          this.cookieDetailsModal?.classList.contains('is-open')
        ) {
          this.closeFlavourDetails();
          return;
        }

        if (this.modal?.classList.contains('is-open')) {
          this.close();
        }
      }

      getPackTrigger(packSize) {
        return this.packTriggers.find(trigger => {
          return Number(trigger.dataset.packSize || 0) === Number(packSize);
        }) || null;
      }

      configurePackFromTrigger(trigger) {
        if (!trigger) {
          return false;
        }

        this.packSize = Number(trigger.dataset.packSize || 0);

        this.packLabel =
          trigger.dataset.packLabel ||
          `${this.packSize} Pack`;

        this.currentDiscountPercent = Math.max(
          0,
          Math.min(
            100,
            Number(trigger.dataset.packDiscount || 0)
          )
        );

        this.currentVariantOptionValue =
          trigger.dataset.packVariantOption ||
          `Box of ${this.packSize}`;

        this.packVariantId =
          trigger.dataset.packVariantId || '';

        this.packAvailable =
          trigger.dataset.packAvailable === 'true';

        const isSingleCookie = this.packSize === 1;

        this.preview?.classList.toggle(
          'is-single-cookie',
          isSingleCookie
        );

        if (this.singleCookieModalNote) {
          this.singleCookieModalNote.hidden =
            !isSingleCookie;
          this.singleCookieModalNote.textContent =
            this.singleCookieNote;
        }

        this.applyPackPreviewSettings(trigger);
        return Boolean(this.packSize);
      }

      getSelectionQuantities() {
        const quantities = new Map();

        this.selection.forEach((item, id) => {
          quantities.set(String(id), Number(item.quantity || 0));
        });

        return quantities;
      }

      rebuildSelectionFromQuantities(quantities) {
        const unavailable = [];
        this.selection.clear();

        this.flavours.forEach(flavour => {
          const id = String(flavour.dataset.flavourId || '');
          const quantityValue = Number(quantities.get(id) || 0);
          const quantityElement = flavour.querySelector('[data-quantity]');

          flavour.dataset.quantity = String(quantityValue);

          if (quantityElement) {
            quantityElement.textContent = String(quantityValue);
          }

          if (quantityValue <= 0) {
            return;
          }

          const available =
            flavour.dataset.available === 'true' &&
            Boolean(flavour.dataset.variantId);

          if (!available) {
            unavailable.push(flavour.dataset.title || 'Selected flavour');
            return;
          }

          this.selection.set(id, {
            id,
            variantId: flavour.dataset.variantId,
            title: flavour.dataset.title,
            image: flavour.dataset.image,
            price: Number(flavour.dataset.price || 0),
            compareAtPrice: Number(
              flavour.dataset.compareAtPrice ||
              flavour.dataset.price ||
              0
            ),
            discountMatches:
              flavour.dataset.discountMatches === 'true',
            quantity: quantityValue
          });
        });

        return unavailable;
      }

      openFourCookieUpsell() {
        if (
          this.packSize !== 1 ||
          this.getSelectedCount() !== 3 ||
          this.fourCookieUpsellShown ||
          !this.fourCookieUpsell
        ) {
          return;
        }

        const fourPackTrigger = this.getPackTrigger(4);

        if (
          !fourPackTrigger ||
          !fourPackTrigger.dataset.packVariantId ||
          fourPackTrigger.dataset.packAvailable !== 'true'
        ) {
          return;
        }

        this.fourCookieUpsellShown = true;

        const discount = Math.max(
          0,
          Number(fourPackTrigger.dataset.packDiscount || 0)
        );

        if (this.fourCookieUpsellCopy) {
          this.fourCookieUpsellCopy.textContent = discount > 0
            ? `Add one more cookie to make a 4-cookie box and save ${discount}% on the box.`
            : 'Add one more cookie to turn your selection into a 4-cookie box.';
        }

        if (this.fourCookieUpsellUpgrade) {
          this.fourCookieUpsellUpgrade.textContent = discount > 0
            ? `Add one more & save ${discount}%`
            : 'Add one more';
        }

        this.fourCookieUpsell.classList.add('is-open');
        this.fourCookieUpsell.setAttribute('aria-hidden', 'false');

        window.setTimeout(() => {
          this.fourCookieUpsellUpgrade?.focus();
        }, 0);
      }

      closeFourCookieUpsell(restoreFocus = true) {
        if (!this.fourCookieUpsell) {
          return;
        }

        this.fourCookieUpsell.classList.remove('is-open');
        this.fourCookieUpsell.setAttribute('aria-hidden', 'true');

        if (restoreFocus) {
          window.setTimeout(() => {
            this.addButton?.focus();
          }, 0);
        }
      }

      upgradeToFourCookieBox() {
        const fourPackTrigger = this.getPackTrigger(4);
        const singlePackTrigger = this.getPackTrigger(1);
        const savedQuantities = this.getSelectionQuantities();

        if (
          !fourPackTrigger ||
          !fourPackTrigger.dataset.packVariantId ||
          fourPackTrigger.dataset.packAvailable !== 'true'
        ) {
          this.closeFourCookieUpsell(false);
          this.showMessage('The 4-cookie box is currently unavailable.');
          return;
        }

        this.configurePackFromTrigger(fourPackTrigger);
        this.resolveFlavourVariants();

        const unavailable = this.rebuildSelectionFromQuantities(
          savedQuantities
        );

        if (unavailable.length) {
          if (singlePackTrigger) {
            this.configurePackFromTrigger(singlePackTrigger);
            this.resolveFlavourVariants();
            this.rebuildSelectionFromQuantities(savedQuantities);
          }

          this.closeFourCookieUpsell(false);
          this.showMessage(
            `The 4-cookie box is not available for ${unavailable.join(', ')}. Keep your 3 cookies or choose another flavour.`
          );
          this.update();
          return;
        }

        this.closeFourCookieUpsell(false);
        this.showMessage(
          'Great — choose 1 more cookie to complete your 4-cookie box.'
        );
        this.update();
      }

      openFlavourDetails(flavour, trigger) {
        if (!flavour || !this.cookieDetailsModal) {
          return;
        }

        this.activeFlavour = flavour;
        this.lastDetailsTrigger = trigger || null;

        const productColour =
          flavour.dataset.productColour || 'var(--builder-accent)';

        this.cookieDetailsModal.style.setProperty(
          '--cookie-product-colour',
          productColour
        );

        if (this.cookieDetailTitle) {
          this.cookieDetailTitle.textContent =
            flavour.dataset.title || 'Cookie';
        }

        if (this.cookieDetailImage) {
          const imageUrl = flavour.dataset.detailImage || '';

          this.cookieDetailImage.hidden = !imageUrl;
          this.cookieDetailImage.src = imageUrl;
          this.cookieDetailImage.alt = imageUrl
            ? flavour.dataset.title || 'Cookie'
            : '';
        }

        const source = flavour.querySelector(
          '[data-flavour-details-source]'
        );

        const tags = source?.querySelector('[data-source-tags]');
        const allergens = source?.querySelector(
          '[data-source-allergens]'
        );

        if (this.cookieDetailTags) {
          this.cookieDetailTags.innerHTML = tags?.innerHTML ||
            '<p class="box-builder__detail-empty">No tags listed.</p>';
        }

        if (this.cookieDetailAllergens) {
          this.cookieDetailAllergens.innerHTML =
            allergens?.innerHTML ||
            '<p class="box-builder__detail-empty">Allergen information is not specified.</p>';
        }

        if (this.cookieDetailProduct) {
          this.cookieDetailProduct.dataset.productUrl =
            flavour.dataset.productUrl || '';
          this.cookieDetailProduct.disabled =
            !flavour.dataset.productUrl;
        }

        this.refreshFlavourDetailsState();

        this.cookieDetailsModal.classList.add('is-open');
        this.cookieDetailsModal.setAttribute('aria-hidden', 'false');

        window.setTimeout(() => {
          this.cookieDetailsModal
            ?.querySelector('.box-builder__cookie-close')
            ?.focus();
        }, 0);
      }

      refreshFlavourDetailsState() {
        const flavour = this.activeFlavour;

        if (!flavour) {
          return;
        }

        const sellingPrice = Number(flavour.dataset.price || 0);
        const compareAtPrice = Math.max(
          sellingPrice,
          Number(flavour.dataset.compareAtPrice || sellingPrice)
        );
        const available = flavour.dataset.available === 'true';
        const selectionLimit = this.getSelectionLimit();
        const boxIsFull =
          Boolean(selectionLimit) &&
          this.getSelectedCount() >= selectionLimit;

        if (this.cookieDetailPrice) {
          this.cookieDetailPrice.textContent = available
            ? this.formatMoney(sellingPrice)
            : 'Unavailable';
        }

        if (this.cookieDetailCompare) {
          const showCompare = available && compareAtPrice > sellingPrice;
          this.cookieDetailCompare.hidden = !showCompare;
          this.cookieDetailCompare.textContent = showCompare
            ? this.formatMoney(compareAtPrice)
            : '';
        }

        if (this.cookieDetailAdd) {
          this.cookieDetailAdd.disabled =
            !available || !this.packSize || boxIsFull;

          this.cookieDetailAdd.textContent = !available
            ? 'Currently unavailable'
            : boxIsFull
              ? 'Your box is full'
              : 'Add to box';
        }
      }

      closeFlavourDetails(restoreFocus = true) {
        if (!this.cookieDetailsModal) {
          return;
        }

        this.cookieDetailsModal.classList.remove('is-open');
        this.cookieDetailsModal.setAttribute('aria-hidden', 'true');

        const trigger = this.lastDetailsTrigger;

        this.activeFlavour = null;
        this.lastDetailsTrigger = null;

        if (restoreFocus && trigger?.isConnected) {
          window.setTimeout(() => trigger.focus(), 0);
        }
      }

      addActiveFlavourFromDetails() {
        const flavour = this.activeFlavour;

        if (!flavour) {
          return;
        }

        const before = this.getSelectedCount();
        this.changeQuantity(flavour, 1);
        const after = this.getSelectedCount();

        if (after > before) {
          this.closeFlavourDetails();
        } else {
          this.refreshFlavourDetailsState();
        }
      }

      openActiveFlavourProduct() {
        const productUrl =
          this.activeFlavour?.dataset.productUrl ||
          this.cookieDetailProduct?.dataset.productUrl || '';

        if (!productUrl) {
          return;
        }

        this.closeFlavourDetails(false);
        this.close();
        window.location.assign(productUrl);
      }

      openFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const requestedPack = params.get('pack');

        if (!requestedPack) {
          return;
        }

        const trigger = this.packTriggers.find(
          item => item.dataset.packSize === requestedPack
        );

        if (trigger) {
          window.setTimeout(() => {
            this.openPack(trigger);
          }, 100);
        }
      }

      setVariable(name, value, unit) {
        if (!this.selectedPreview) {
          return;
        }

        this.selectedPreview.style.setProperty(
          name,
          `${value}${unit}`
        );
      }

      applyPackPreviewSettings(trigger) {
        this.setVariable(
          '--pack-desktop-grid-x',
          trigger.dataset.desktopGridX || 20,
          '%'
        );

        this.setVariable(
          '--pack-desktop-grid-y',
          trigger.dataset.desktopGridY || 35,
          '%'
        );

        this.setVariable(
          '--pack-desktop-grid-width',
          trigger.dataset.desktopGridWidth || 60,
          '%'
        );

        this.setVariable(
          '--pack-desktop-grid-height',
          trigger.dataset.desktopGridHeight || 40,
          '%'
        );

        this.setVariable(
          '--pack-desktop-cookie-width',
          trigger.dataset.desktopCookieWidth || 84,
          '%'
        );

        this.setVariable(
          '--pack-desktop-cookie-height',
          trigger.dataset.desktopCookieHeight || 84,
          '%'
        );

        this.setVariable(
          '--pack-desktop-gap-x',
          trigger.dataset.desktopGapX || 4,
          '%'
        );

        this.setVariable(
          '--pack-desktop-gap-y',
          trigger.dataset.desktopGapY || 4,
          '%'
        );

        this.setVariable(
          '--pack-desktop-grid-padding',
          trigger.dataset.desktopGridPadding || 0,
          'px'
        );

        this.setVariable(
          '--pack-desktop-cookie-rotation',
          trigger.dataset.desktopCookieRotation || 0,
          'deg'
        );

        this.setVariable(
          '--pack-mobile-grid-x',
          trigger.dataset.mobileGridX || 20,
          '%'
        );

        this.setVariable(
          '--pack-mobile-grid-y',
          trigger.dataset.mobileGridY || 35,
          '%'
        );

        this.setVariable(
          '--pack-mobile-grid-width',
          trigger.dataset.mobileGridWidth || 60,
          '%'
        );

        this.setVariable(
          '--pack-mobile-grid-height',
          trigger.dataset.mobileGridHeight || 40,
          '%'
        );

        this.setVariable(
          '--pack-mobile-cookie-width',
          trigger.dataset.mobileCookieWidth || 84,
          '%'
        );

        this.setVariable(
          '--pack-mobile-cookie-height',
          trigger.dataset.mobileCookieHeight || 84,
          '%'
        );

        this.setVariable(
          '--pack-mobile-gap-x',
          trigger.dataset.mobileGapX || 4,
          '%'
        );

        this.setVariable(
          '--pack-mobile-gap-y',
          trigger.dataset.mobileGapY || 4,
          '%'
        );

        this.setVariable(
          '--pack-mobile-grid-padding',
          trigger.dataset.mobileGridPadding || 0,
          'px'
        );

        this.setVariable(
          '--pack-mobile-cookie-rotation',
          trigger.dataset.mobileCookieRotation || 0,
          'deg'
        );
      }

      openPack(trigger) {
        this.configurePackFromTrigger(trigger);

        if (!this.packSize || !this.modal) {
          return;
        }

        this.fourCookieUpsellShown = false;
        this.closeFourCookieUpsell(false);

        this.resetSelection();
        this.resolveFlavourVariants();

        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');

        document.body.classList.add('box-builder-open');
        document.documentElement.classList.add('box-builder-open');

        if (
          this.packSize !== 1 &&
          !this.packVariantId
        ) {
          this.showMessage(
            'Select a Shopify pack product for this block in the Theme Editor.'
          );
        } else if (
          this.packSize !== 1 &&
          !this.packAvailable
        ) {
          this.showMessage(
            'This pack is currently unavailable.'
          );
        } else {
          this.showMessage('');
        }

        this.update();
      }

      close() {
        if (!this.modal) {
          return;
        }

        this.closeFlavourDetails(false);
        this.closeFourCookieUpsell(false);

        this.modal.classList.remove('is-open');
        this.modal.setAttribute('aria-hidden', 'true');

        document.body.classList.remove('box-builder-open');
        document.documentElement.classList.remove('box-builder-open');

        this.resetSelection();

        this.packSize = 0;
        this.packLabel = '';
        this.packVariantId = '';
        this.packAvailable = false;
        this.currentDiscountPercent = 0;
        this.currentVariantOptionValue = '';
        this.fourCookieUpsellShown = false;

        this.preview?.classList.remove(
          'is-single-cookie'
        );

        if (this.singleCookieModalNote) {
          this.singleCookieModalNote.hidden = true;
        }

        if (this.selectedPreview) {
          this.selectedPreview.innerHTML = '';
          this.selectedPreview.dataset.packSize = '1';
        }

        if (this.selectedCountElement) {
          this.selectedCountElement.textContent = '0';
        }

        if (this.requiredCountElement) {
          this.requiredCountElement.textContent = '0';
        }

        if (this.previewPack) {
          this.previewPack.textContent = 'Select a pack';
        }

        if (this.countMessage) {
          this.countMessage.textContent = 'Choose a pack to begin';
        }

        if (this.countProgress) {
          this.countProgress.style.width = '0%';
        }

        if (this.packPrice) {
          this.packPrice.textContent = '';
        }

        if (this.packDiscountLabels.length) {
          this.packDiscountLabels.forEach(label => {
            label.textContent = '';
            label.classList.remove('is-visible');
          });
        }

        if (this.addPrice) {
          this.addPrice.textContent = '';
        }

        if (this.addLabel) {
          this.addLabel.textContent = 'Complete your box';
        }

        if (this.addButton) {
          this.addButton.disabled = true;
        }

        this.showMessage('');
      }

      resetSelection() {
        this.selection.clear();

        this.flavours.forEach(flavour => {
          flavour.dataset.quantity = '0';

          const quantity = flavour.querySelector('[data-quantity]');
          const decrease = flavour.querySelector('[data-decrease]');

          if (quantity) {
            quantity.textContent = '0';
          }

          if (decrease) {
            decrease.disabled = true;
          }
        });
      }

      getSelectedCount() {
        let total = 0;

        this.selection.forEach(item => {
          total += item.quantity;
        });

        return total;
      }

      getSelectionLimit() {
        return this.packSize === 1
          ? this.singleCookieLimit
          : this.packSize;
      }

      getSelectedSubtotal() {
        let subtotal = 0;

        this.selection.forEach(item => {
          subtotal += item.price * item.quantity;
        });

        return subtotal;
      }

      getSelectedCompareSubtotal() {
        let subtotal = 0;

        this.selection.forEach(item => {
          subtotal += item.compareAtPrice * item.quantity;
        });

        return subtotal;
      }

      formatMoney(cents) {
        const amount = Number(cents || 0) / 100;

        try {
          return new Intl.NumberFormat(
            document.documentElement.lang || 'en-IN',
            {
              style: 'currency',
              currency: this.currencyCode,
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            }
          ).format(amount);
        } catch (error) {
          return `${this.currencyCode} ${amount.toFixed(2)}`;
        }
      }

      createBoxId() {
        const randomPart =
          window.crypto?.randomUUID?.() ||
          Math.random().toString(36).slice(2, 12);

        return `BYB-${Date.now()}-${randomPart}`;
      }

      normaliseOptionValue(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/\s+/g, ' ');
      }

      getFlavourVariants(flavour) {
        if (Array.isArray(flavour.boxVariants)) {
          return flavour.boxVariants;
        }

        const source = flavour.querySelector(
          '[data-flavour-variants]'
        );

        if (!source) {
          flavour.boxVariants = [];
          return flavour.boxVariants;
        }

        try {
          const parsed = JSON.parse(source.textContent || '[]');
          flavour.boxVariants = Array.isArray(parsed)
            ? parsed
            : [];
        } catch (error) {
          console.error(
            'Unable to read cookie variants for Build Your Box.',
            error
          );
          flavour.boxVariants = [];
        }

        return flavour.boxVariants;
      }

      findVariantForCurrentPack(flavour) {
        const variants = this.getFlavourVariants(flavour);

        if (this.packSize === 1) {
          const defaultVariantId = String(
            flavour.dataset.defaultVariantId || ''
          );

          return variants.find(variant => {
            return String(variant.id) === defaultVariantId;
          }) || variants.find(variant => variant.available) || variants[0] || null;
        }

        const target = this.normaliseOptionValue(
          this.currentVariantOptionValue
        );

        if (!target) {
          return null;
        }

        return variants.find(variant => {
          const options = Array.isArray(variant.options)
            ? variant.options
            : [];

          return options.some(option => {
            return this.normaliseOptionValue(option) === target;
          });
        }) || null;
      }

      variantMatchesConfiguredDiscount(variant) {
        const price = Number(variant?.price || 0);
        const compareAtPrice = Number(
          variant?.compareAtPrice || price
        );

        if (
          !this.currentDiscountPercent ||
          compareAtPrice <= price
        ) {
          return this.currentDiscountPercent === 0;
        }

        const expectedPrice = Math.round(
          compareAtPrice *
          (100 - this.currentDiscountPercent) / 100
        );

        return Math.abs(expectedPrice - price) <= 1;
      }

      resolveFlavourVariants() {
        this.flavours.forEach(flavour => {
          const variant = this.findVariantForCurrentPack(flavour);
          const sellingPrice = Number(variant?.price || 0);
          const compareAtPrice = Math.max(
            sellingPrice,
            Number(variant?.compareAtPrice || sellingPrice)
          );
          const available = Boolean(
            variant && variant.available
          );

          flavour.dataset.variantId = variant
            ? String(variant.id)
            : '';
          flavour.dataset.price = String(sellingPrice);
          flavour.dataset.compareAtPrice = String(compareAtPrice);
          flavour.dataset.available = available
            ? 'true'
            : 'false';
          flavour.dataset.discountMatches =
            this.variantMatchesConfiguredDiscount(variant)
              ? 'true'
              : 'false';

          const compareElement = flavour.querySelector(
            '[data-flavour-compare]'
          );
          const sellingElement = flavour.querySelector(
            '[data-flavour-selling]'
          );
          const statusElement = flavour.querySelector(
            '[data-flavour-status]'
          );
          const increase = flavour.querySelector(
            '[data-increase]'
          );

          if (sellingElement) {
            sellingElement.textContent = variant
              ? this.formatMoney(sellingPrice)
              : 'Unavailable';
          }

          if (compareElement) {
            const showCompareAt =
              Boolean(variant) &&
              compareAtPrice > sellingPrice;

            compareElement.hidden = !showCompareAt;
            compareElement.textContent = showCompareAt
              ? this.formatMoney(compareAtPrice)
              : '';
          }

          if (statusElement) {
            if (!variant) {
              statusElement.textContent =
                `No “${this.currentVariantOptionValue}” variant`;
              statusElement.hidden = false;
            } else if (!available) {
              statusElement.textContent = 'Sold out';
              statusElement.hidden = false;
            } else {
              statusElement.textContent = '';
              statusElement.hidden = true;
            }
          }

          if (increase) {
            increase.disabled = !available;
          }
        });
      }

      changeQuantity(flavour, amount) {
        const selectedCount = this.getSelectedCount();
        const selectionLimit = this.getSelectionLimit();
        const id = flavour.dataset.flavourId;

        const available =
          flavour.dataset.available === 'true';

        if (!available || !this.packSize) {
          return;
        }

        const currentItem = this.selection.get(id);
        const currentQuantity = currentItem?.quantity || 0;

        if (amount > 0 && selectedCount >= selectionLimit) {
          this.showMessage(
            this.packSize === 1
              ? `You can add up to ${this.singleCookieLimit} individually packed cookies.`
              : `Your ${this.packLabel} is already full.`
          );

          return;
        }

        const nextQuantity = Math.max(
          0,
          currentQuantity + amount
        );

        if (nextQuantity === 0) {
          this.selection.delete(id);
        } else {
          this.selection.set(id, {
            id,
            variantId: flavour.dataset.variantId,
            title: flavour.dataset.title,
            image: flavour.dataset.image,
            price: Number(flavour.dataset.price || 0),
            compareAtPrice: Number(
              flavour.dataset.compareAtPrice ||
              flavour.dataset.price ||
              0
            ),
            discountMatches:
              flavour.dataset.discountMatches === 'true',
            quantity: nextQuantity
          });
        }

        flavour.dataset.quantity = String(nextQuantity);

        const quantity = flavour.querySelector('[data-quantity]');

        if (quantity) {
          quantity.textContent = String(nextQuantity);
        }

        this.showMessage('');
        this.update();

        const updatedCount = this.getSelectedCount();
        const reachedThreeSingles =
          this.packSize === 1 &&
          amount > 0 &&
          selectedCount < 3 &&
          updatedCount === 3;

        if (reachedThreeSingles) {
          window.setTimeout(() => {
            this.openFourCookieUpsell();
          }, 0);
        }
      }

      update() {
        const selectedCount = this.getSelectedCount();
        const selectionLimit = this.getSelectionLimit();
        const isSingleCookie = this.packSize === 1;

        const remaining = Math.max(
          0,
          selectionLimit - selectedCount
        );

        const complete = isSingleCookie
          ? selectedCount >= 1 && selectedCount <= selectionLimit
          : this.packSize > 0 && selectedCount === this.packSize;

        const atLimit =
          selectionLimit > 0 &&
          selectedCount >= selectionLimit;

        const subtotal = this.getSelectedSubtotal();
        const compareSubtotal =
          this.getSelectedCompareSubtotal();

        const subtotalText = this.formatMoney(subtotal);
        const compareSubtotalText =
          this.formatMoney(compareSubtotal);
        const finalText = subtotalText;

        if (this.selectedCountElement) {
          this.selectedCountElement.textContent =
            String(selectedCount);
        }

        if (this.requiredCountElement) {
          this.requiredCountElement.textContent =
            String(selectionLimit);
        }

        if (this.previewPack) {
          this.previewPack.textContent =
            this.packLabel || 'Select a pack';
        }

        if (this.packPrice) {
          if (!selectedCount) {
            this.packPrice.textContent = '';
          } else if (compareSubtotal > subtotal) {
            this.packPrice.textContent =
              `${compareSubtotalText} → ${finalText}`;
          } else {
            this.packPrice.textContent = finalText;
          }
        }

        if (this.packDiscountLabels.length) {
          this.packDiscountLabels.forEach(label => {
            if (
              !isSingleCookie &&
              this.currentDiscountPercent > 0
            ) {
              label.textContent =
                `Save ${this.currentDiscountPercent}%`;
              label.classList.add('is-visible');
            } else {
              label.textContent = '';
              label.classList.remove('is-visible');
            }
          });
        }

        if (this.addPrice) {
          this.addPrice.textContent = selectedCount
            ? finalText
            : '';
        }

        if (this.countMessage) {
          if (isSingleCookie) {
            this.countMessage.textContent = !selectedCount
              ? `Choose 1 to ${selectionLimit} cookies`
              : atLimit
                ? `Maximum ${selectionLimit} cookies selected`
                : `You can add up to ${remaining} more`;
          } else {
            this.countMessage.textContent = complete
              ? 'Your box is complete'
              : `Add ${remaining} more`;
          }
        }

        if (this.countProgress) {
          const percentage = selectionLimit
            ? Math.min(
                100,
                (selectedCount / selectionLimit) * 100
              )
            : 0;

          this.countProgress.style.width =
            `${percentage}%`;
        }

        const packReady =
          isSingleCookie ||
          (
            Boolean(this.packVariantId) &&
            this.packAvailable
          );

        if (this.addButton) {
          this.addButton.disabled =
            !complete || !packReady;
        }

        if (this.addLabel) {
          if (complete) {
            this.addLabel.textContent = isSingleCookie
              ? `Add ${selectedCount} cookie${selectedCount === 1 ? '' : 's'} to cart`
              : 'Add box to cart';
          } else {
            this.addLabel.textContent = isSingleCookie
              ? 'Choose at least 1 cookie'
              : `Add ${remaining} more`;
          }
        }

        this.flavours.forEach(flavour => {
          const quantity = Number(
            flavour.dataset.quantity || 0
          );

          const decrease = flavour.querySelector(
            '[data-decrease]'
          );

          const increase = flavour.querySelector(
            '[data-increase]'
          );

          const available =
            flavour.dataset.available === 'true';

          if (decrease) {
            decrease.disabled = quantity <= 0;
          }

          if (increase) {
            increase.disabled =
              !available || atLimit;
          }
        });

        if (this.selectedPreview) {
          this.selectedPreview.dataset.packSize = isSingleCookie
            ? String(Math.max(1, selectedCount))
            : String(this.packSize || 1);
        }

        if (
          window.Shopify?.designMode &&
          !isSingleCookie &&
          complete &&
          Array.from(this.selection.values()).some(
            item => !item.discountMatches
          )
        ) {
          this.showMessage(
            `Theme editor note: one or more “${this.currentVariantOptionValue}” variant prices do not match the configured ${this.currentDiscountPercent}% label.`
          );
        }

        this.renderPreview();

        if (
          this.cookieDetailsModal?.classList.contains('is-open')
        ) {
          this.refreshFlavourDetailsState();
        }
      }

      renderPreview() {
        if (!this.selectedPreview) {
          return;
        }

        this.selectedPreview.innerHTML = '';

        this.selection.forEach(item => {
          for (
            let index = 0;
            index < item.quantity;
            index += 1
          ) {
            if (!item.image) {
              continue;
            }

            const image = document.createElement('img');

            image.src = item.image;
            image.alt = item.title || '';
            image.className =
              'box-builder__preview-cookie';
            image.loading = 'lazy';
            image.draggable = false;

            this.selectedPreview.appendChild(image);
          }
        });
      }

      buildFlavourSummary() {
        return Array.from(this.selection.values())
          .map(item => {
            return `${item.quantity} × ${item.title}`;
          })
          .join(', ');
      }

      async addToCart() {
        const selectedCount = this.getSelectedCount();
        const selectionLimit = this.getSelectionLimit();
        const selectionIsValid = this.packSize === 1
          ? selectedCount >= 1 && selectedCount <= selectionLimit
          : selectedCount === this.packSize;

        if (!selectionIsValid) {
          return;
        }

        if (
          this.packSize !== 1 &&
          (!this.packVariantId || !this.packAvailable)
        ) {
          this.showMessage(
            'This pack is not available.'
          );

          return;
        }

        this.addButton.disabled = true;

        this.showMessage(
          this.packSize === 1
            ? 'Adding your cookie to the cart…'
            : 'Adding your box to the cart…'
        );

        let items = [];

        if (this.packSize === 1) {
          const selectedItems = Array.from(
            this.selection.values()
          ).filter(item => item.variantId);

          if (!selectedItems.length) {
            this.showMessage(
              'Select at least one available cookie.'
            );
            this.addButton.disabled = false;
            return;
          }

          items = selectedItems.map(item => ({
            id: Number(item.variantId),
            quantity: item.quantity,
            properties: {
              _selected_via_builder: 'true',
              _single_cookie: 'true',
              Packaging: this.singleCookieNote
            }
          }));
        } else {
          const boxId = this.createBoxId();
          const parentVariantId =
            Number(this.packVariantId);

          const parentProperties = {
            _box_id: boxId,
            _box_parent: 'true',
            _box_size: String(this.packSize),
            _box_discount_percent: String(
              this.currentDiscountPercent
            ),
            _box_variant_option:
              this.currentVariantOptionValue,

            /* Visible parent information */
            'Pack size': this.packLabel,
            'Box discount':
              `${this.currentDiscountPercent}%`,

            /* Hidden because nested cookie lines already show quantities */
            _selected_flavours:
              this.buildFlavourSummary()
          };

          items = [
            {
              id: parentVariantId,
              quantity: 1,
              properties: parentProperties
            },
            ...Array.from(
              this.selection.values()
            ).map(item => ({
              id: Number(item.variantId),
              quantity: item.quantity,
              parent_id: parentVariantId,
              properties: {
                _box_id: boxId,
                _box_component: 'true',
                _box_size: String(this.packSize),
                _box_discount_percent: String(
                  this.currentDiscountPercent
                ),
                _box_variant_option:
                  this.currentVariantOptionValue
              }
            }))
          ];
        }

        try {
          const root =
            window.Shopify?.routes?.root || '/';

          const response = await fetch(
            `${root}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ items })
            }
          );

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
              result.message ||
              'Unable to add this box to the cart.'
            );
          }

          window.location.href = `${root}cart`;
        } catch (error) {
          this.showMessage(
            error.message ||
            'Unable to add this box to the cart.'
          );

          this.addButton.disabled = false;
        }
      }

      showMessage(text) {
        if (this.message) {
          const message = String(text || '').trim();

          this.message.textContent = message;
          this.message.hidden = !message;
        }
      }
    }

    const initialize = root => {
      const sections = [];

      if (
        root instanceof Element &&
        root.matches(selector)
      ) {
        sections.push(root);
      }

      if (root.querySelectorAll) {
        sections.push(
          ...root.querySelectorAll(selector)
        );
      }

      sections.forEach(section => {
        if (section.boxBuilderInstance) {
          return;
        }

        section.boxBuilderInstance =
          new BoxBuilder(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initialize(document),
        { once: true }
      );
    } else {
      initialize(document);
    }

    document.addEventListener(
      'shopify:section:load',
      event => {
        initialize(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["domus-navbar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-domus-navbar]';

    class DomusNavbar {
      constructor(section) {
        this.section = section;
        this.openButton = section.querySelector(
          '[data-domus-menu-open]'
        );
        this.drawer = section.querySelector(
          '[data-domus-menu-drawer]'
        );
        this.closeButtons = Array.from(
          section.querySelectorAll('[data-domus-menu-close]')
        );

        this.handleEscape = this.handleEscape.bind(this);

        this.bindEvents();
      }

      bindEvents() {
        this.openButton?.addEventListener('click', () => {
          this.open();
        });

        this.closeButtons.forEach(button => {
          button.addEventListener('click', () => {
            this.close();
          });
        });

        document.addEventListener('keydown', this.handleEscape);
      }

      open() {
        if (!this.drawer) {
          return;
        }

        this.drawer.classList.add('is-open');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.openButton?.setAttribute('aria-expanded', 'true');

        document.documentElement.classList.add('domus-menu-open');
        document.body.classList.add('domus-menu-open');

        const closeButton = this.drawer.querySelector(
          '[data-domus-menu-close]'
        );

        closeButton?.focus();
      }

      close() {
        if (!this.drawer) {
          return;
        }

        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.openButton?.setAttribute('aria-expanded', 'false');

        document.documentElement.classList.remove('domus-menu-open');
        document.body.classList.remove('domus-menu-open');

        this.openButton?.focus();
      }

      handleEscape(event) {
        if (
          event.key === 'Escape' &&
          this.drawer?.classList.contains('is-open')
        ) {
          this.close();
        }
      }
    }

    const initialize = root => {
      const sections = [];

      if (
        root instanceof Element &&
        root.matches(selector)
      ) {
        sections.push(root);
      }

      if (root.querySelectorAll) {
        sections.push(...root.querySelectorAll(selector));
      }

      sections.forEach(section => {
        if (section.domusNavbarInstance) {
          return;
        }

        section.domusNavbarInstance =
          new DomusNavbar(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initialize(document),
        { once: true }
      );
    } else {
      initialize(document);
    }

    document.addEventListener(
      'shopify:section:load',
      event => {
        initialize(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-drag-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-featured-carousel]';

    class FeaturedCarousel {
      constructor(section) {
        this.section = section;

        this.viewport = section.querySelector(
          '[data-carousel-viewport]'
        );

        this.track = section.querySelector(
          '[data-carousel-track]'
        );

        this.slides = Array.from(
          section.querySelectorAll(
            '[data-carousel-slide]'
          )
        );

        this.indicators = Array.from(
          section.querySelectorAll(
            '[data-carousel-indicator]'
          )
        );

        this.previousButton = section.querySelector(
          '[data-carousel-previous]'
        );

        this.nextButton = section.querySelector(
          '[data-carousel-next]'
        );

        this.activeIndex = 0;
        this.dragStartX = null;
        this.dragOffset = 0;
        this.pointerId = null;
        this.timer = null;
        this.isDragging = false;

        this.reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.autoplay =
          section.dataset.autoplay === 'true' &&
          !this.reducedMotion;

        if (
          !this.viewport ||
          !this.track ||
          this.slides.length === 0
        ) {
          return;
        }

        this.bindEvents();
        this.update(false);
        this.startTimer();
      }

      bindEvents() {
        this.handlePointerDown =
          this.onPointerDown.bind(this);

        this.handlePointerMove =
          this.onPointerMove.bind(this);

        this.handlePointerEnd =
          this.onPointerEnd.bind(this);

        this.handleVisibilityChange =
          this.onVisibilityChange.bind(this);

        this.viewport.addEventListener(
          'pointerdown',
          this.handlePointerDown
        );

        this.viewport.addEventListener(
          'pointermove',
          this.handlePointerMove
        );

        this.viewport.addEventListener(
          'pointerup',
          this.handlePointerEnd
        );

        this.viewport.addEventListener(
          'pointercancel',
          this.handlePointerEnd
        );

        this.viewport.addEventListener(
          'dragstart',
          event => event.preventDefault()
        );

        this.previousButton?.addEventListener(
          'click',
          () => {
            this.goTo(this.activeIndex - 1);
          }
        );

        this.nextButton?.addEventListener(
          'click',
          () => {
            this.goTo(this.activeIndex + 1);
          }
        );

        this.indicators.forEach(indicator => {
          indicator.addEventListener(
            'click',
            () => {
              const index = Number(
                indicator.dataset.slideIndex
              );

              this.goTo(index);
            }
          );
        });

        this.section.addEventListener(
          'mouseenter',
          () => this.stopTimer()
        );

        this.section.addEventListener(
          'mouseleave',
          () => this.startTimer()
        );

        this.section.addEventListener(
          'focusin',
          () => this.stopTimer()
        );

        this.section.addEventListener(
          'focusout',
          event => {
            if (
              !this.section.contains(
                event.relatedTarget
              )
            ) {
              this.startTimer();
            }
          }
        );

        document.addEventListener(
          'visibilitychange',
          this.handleVisibilityChange
        );

        window.addEventListener(
          'resize',
          () => this.applyTransform()
        );
      }

      onPointerDown(event) {
        if (
          event.button !== 0 ||
          event.target.closest(
            'a, button, input, select, textarea'
          )
        ) {
          return;
        }

        this.dragStartX = event.clientX;
        this.dragOffset = 0;
        this.pointerId = event.pointerId;
        this.isDragging = true;

        this.stopTimer();

        this.viewport.classList.add(
          'is-dragging'
        );

        this.viewport.setPointerCapture(
          event.pointerId
        );
      }

      onPointerMove(event) {
        if (
          this.dragStartX === null ||
          event.pointerId !== this.pointerId
        ) {
          return;
        }

        this.dragOffset =
          event.clientX - this.dragStartX;

        this.applyTransform();
      }

      onPointerEnd(event) {
        if (
          this.dragStartX === null ||
          event.pointerId !== this.pointerId
        ) {
          return;
        }

        const threshold = Math.min(
          90,
          this.viewport.clientWidth * 0.14
        );

        if (this.dragOffset <= -threshold) {
          this.activeIndex =
            (this.activeIndex + 1) %
            this.slides.length;
        } else if (
          this.dragOffset >= threshold
        ) {
          this.activeIndex =
            (
              this.activeIndex -
              1 +
              this.slides.length
            ) %
            this.slides.length;
        }

        if (
          this.viewport.hasPointerCapture(
            event.pointerId
          )
        ) {
          this.viewport.releasePointerCapture(
            event.pointerId
          );
        }

        this.dragStartX = null;
        this.dragOffset = 0;
        this.pointerId = null;
        this.isDragging = false;

        this.viewport.classList.remove(
          'is-dragging'
        );

        this.update();
      }

      applyTransform() {
        const baseOffset =
          this.activeIndex *
          this.viewport.clientWidth;

        this.track.style.transform =
          `translate3d(${
            -(baseOffset - this.dragOffset)
          }px, 0, 0)`;
      }

      goTo(index) {
        this.activeIndex =
          (
            index +
            this.slides.length
          ) %
          this.slides.length;

        this.dragOffset = 0;

        this.update();
      }

      update(restartTimer = true) {
        this.applyTransform();

        this.slides.forEach(
          (slide, index) => {
            const isActive =
              index === this.activeIndex;

            slide.setAttribute(
              'aria-hidden',
              String(!isActive)
            );

            slide
              .querySelectorAll(
                '[data-carousel-focusable]'
              )
              .forEach(element => {
                element.tabIndex =
                  isActive ? 0 : -1;
              });
          }
        );

        this.indicators.forEach(
          (indicator, index) => {
            const isActive =
              index === this.activeIndex;

            indicator.classList.toggle(
              'is-active',
              isActive
            );

            indicator.setAttribute(
              'aria-current',
              isActive ? 'true' : 'false'
            );

            const progress =
              indicator.querySelector(
                '.featured-carousel__indicator-progress'
              );

            if (!progress) {
              return;
            }

            progress.style.animation = 'none';

            void progress.offsetWidth;

            if (isActive) {
              const duration =
                this.getActiveDuration();

              indicator.style.setProperty(
                '--indicator-duration',
                `${duration}ms`
              );

              progress.style.animation = '';
            }
          }
        );

        if (restartTimer) {
          this.startTimer();
        }
      }

      getActiveDuration() {
        return (
          Number(
            this.slides[
              this.activeIndex
            ]?.dataset.duration
          ) || 5000
        );
      }

      startTimer() {
        this.stopTimer();

        if (
          !this.autoplay ||
          this.slides.length < 2 ||
          document.hidden
        ) {
          return;
        }

        this.timer = window.setTimeout(
          () => {
            this.goTo(
              this.activeIndex + 1
            );
          },
          this.getActiveDuration()
        );
      }

      stopTimer() {
        if (!this.timer) {
          return;
        }

        window.clearTimeout(this.timer);

        this.timer = null;
      }

      onVisibilityChange() {
        if (document.hidden) {
          this.stopTimer();
        } else {
          this.startTimer();
        }
      }

      destroy() {
        this.stopTimer();

        this.viewport?.removeEventListener(
          'pointerdown',
          this.handlePointerDown
        );

        this.viewport?.removeEventListener(
          'pointermove',
          this.handlePointerMove
        );

        this.viewport?.removeEventListener(
          'pointerup',
          this.handlePointerEnd
        );

        this.viewport?.removeEventListener(
          'pointercancel',
          this.handlePointerEnd
        );

        document.removeEventListener(
          'visibilitychange',
          this.handleVisibilityChange
        );
      }
    }

    const initialize = root => {
      const carousels = root.matches?.(selector)
        ? [root]
        : Array.from(
            root.querySelectorAll?.(selector) || []
          );

      carousels.forEach(carousel => {
        if (
          carousel.featuredCarouselInstance
        ) {
          carousel
            .featuredCarouselInstance
            .destroy();
        }

        carousel.featuredCarouselInstance =
          new FeaturedCarousel(carousel);
      });
    };

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initialize(document);
      }
    );

    document.addEventListener(
      'shopify:section:load',
      event => {
        initialize(event.target);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      event => {
        const carousel =
          event.target.querySelector?.(
            selector
          );

        carousel
          ?.featuredCarouselInstance
          ?.destroy();
      }
    );

    document.addEventListener(
      'shopify:block:select',
      event => {
        const slide =
          event.target.closest?.(
            '[data-carousel-slide]'
          );

        const carousel =
          event.target.closest?.(
            selector
          );

        if (
          !slide ||
          !carousel
            ?.featuredCarouselInstance
        ) {
          return;
        }

        carousel
          .featuredCarouselInstance
          .goTo(
            Number(
              slide.dataset.slideIndex
            )
          );
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
